<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M9.91218 4.97276C10.1335 4.76475 10.1443 4.41667 9.93633 4.19532C9.72832 3.97396 9.38025 3.96315 9.15889 4.17116L6 7.13966L2.84111 4.17116C2.61975 3.96315 2.27168 3.97396 2.06367 4.19532C1.85565 4.41667 1.86647 4.76475 2.08782 4.97276L5.62336 8.2952C5.83505 8.49413 6.16495 8.49413 6.37664 8.2952L9.91218 4.97276Z"
      :fill="color"
      :stroke="color"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
  export default {
    props: {
      width: {
        type: [Number, String],
        default: 38,
      },
      height: {
        type: [Number, String],
        default: 38,
      },
      color: {
        type: String,
        default: 'currentColor',
      },
    },

    computed: {
      viewBox() {
        return `0 0 ${this.width} ${this.height}`
      },
    },
  }
</script>
